import React from 'react';
import styles from './AdvtFullSize.module.css';
import { useGetParams } from '../../hooks/useGetParams';

import logo from '../../assets/images/logo.png';
const AdvtFullSize = React.memo(() => {
  const { paddingQR, sizeQR, titleFontSize, qrCode1, qrCode2, title } =
    useGetParams();

  return (
    <div className={styles.wrapper}>
      <img src={logo} alt="logo" className={styles.logo} />
      <div className={styles.qrsWrapper}>
        {title && (
          <div className={styles.titleBlock}>
            <div
              className={styles.title}
              style={{ fontSize: `${titleFontSize}rem` }}
            >
              {title}
            </div>
            <div className={styles.leftTop} />
            <div className={styles.rightTop} />
            <div className={styles.rightBottom} />
            <div className={styles.leftBottom} />
          </div>
        )}

        {(qrCode1 || qrCode2) && (
          <div className={styles.qrBlock}>
            <div className={styles.qrItem}>
              {qrCode1 && (
                <div
                  className={styles.qrCode}
                  style={{
                    width: `${sizeQR}rem`,
                    height: `${sizeQR}rem`,
                    padding: `${paddingQR}rem`,
                  }}
                >
                  <img src={qrCode1} alt="qrCode1" />
                </div>
              )}
            </div>
            <div className={styles.qrItem}>
              {qrCode2 && (
                <div
                  className={styles.qrCode}
                  style={{
                    width: `${sizeQR}rem`,
                    height: `${sizeQR}rem`,
                    padding: `${paddingQR}rem`,
                  }}
                >
                  <img src={qrCode2} alt="qrCode1" />
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
});

export default AdvtFullSize;
